import { AddCircleOutline, ArrowBack, Delete, Edit, Info } from '@mui/icons-material'
import { Button, Card, CardContent, CardHeader, Container, CssBaseline, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, Outlet, useOutletContext } from 'react-router-dom'
import Swal from 'sweetalert2'
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs'
import MyTable from '../../../../components/MyTable'
import { AuthStore } from '../../../../store/UserStore'
import { base_url } from '../../../../utils/GlobalVariables'
import { CustomDescrypt } from '../../../../utils/MyEncryption'
import Form from './Form'

const Verifikator = () => {
    const [breadcrumbItem, setBreadcrumbItem] = useState({})

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="Verifikator" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Outlet context={{ setBreadcrumbItem }} />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const Data = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogData, setDialogData] = useState({});
    const [deleting, setDeleting] = useState(false);
    const [edit, setEdit] = useState(null);

    useEffect(() => {
        setBreadcrumbItem({ '/admin': 'Home', '': 'Validator' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns = [
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            filterable: false,
            hideable: false,
            width: 150,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {
                const onDelete = (e) => {
                    setDeleting(!deleting);
                    const frmData = {
                        _method: 'DELETE',
                        username: params.row.username
                    }

                    Swal.fire({
                        title: 'Hapus Data?',
                        text: "Operasi tidak dapat Dikembalikan!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        showLoaderOnConfirm: true,
                        confirmButtonText: 'Ya, Hapus!',
                        cancelButtonText: 'Batal',
                        preConfirm: () => {
                            return axios.post(
                                base_url + '/admin/verifikator/delete',
                                frmData,
                                {
                                    headers: {
                                        'Authorization': `Bearer ${decryptedUser.token}`,
                                        'content-type': 'multipart/form-data'
                                    }
                                })
                                .then((response) => {
                                    requestData();
                                    return response.data
                                })
                                .catch((error) => {
                                    if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                                        logOut();
                                    }
                                    else {
                                        console.log(error.response);
                                        Swal.showValidationMessage(
                                            `Request failed: ${error.response.statusText}`
                                        )
                                    }
                                })
                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    }).then((result) => {
                        console.log(result);
                        if (result.isConfirmed) {
                            Swal.fire(
                                'Selesai!',
                                result.value,
                                'success'
                            )
                        }
                    })

                }

                const onEdit = () => {
                    console.log(params.row);
                    setEdit(params.row)
                }

                const onOption = (params) => {
                    // handleOpenDialog(params)
                }

                return (
                    <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Hapus">
                            <IconButton aria-label="delete" color='error' onClick={onDelete}>
                                <Delete />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit">
                            <IconButton aria-label="edit" color="info" onClick={onEdit}>
                                <Edit />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Lihat Data">
                            <IconButton aria-label="confirm" color='success' onClick={() => onOption(params.row)}>
                                <Info />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                );
            },
        },
        { field: 'nama', headerName: 'Nama', width: 350 },
        {
            field: 'nip',
            headerName: 'NIP',
            minWidth: 150,
        },
        {
            field: 'username',
            headerName: 'Username',
            minWidth: 200,
        },
        {
            field: 'password',
            headerName: 'Password',
            minWidth: 200,
        }
    ];

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleting, edit])

    const requestData = () => {
        setTableLoading(true)
        axios.get(
            base_url + '/admin/verifikator',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                console.log(response);
                setTableData(response.data)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setTableLoading(false)
            })
    }

    return (

        <>
            {edit === null ?
                <Card>
                    <CardHeader
                        title="Validator"
                        action={
                            <Button
                                variant="contained"
                                endIcon={<AddCircleOutline color='white' />}
                                to="/admin/verifikator/add"
                                component={Link}
                            >
                                Tambah
                            </Button>
                        }
                    />
                    <CardContent>
                        <MyTable
                            rows={tableData}
                            columns={columns}
                            row_id={(row) => row.nip}
                            isLoading={tableLoading}
                        />
                        {/* jhjkhzxcjk */}
                    </CardContent>
                </Card>
                :
                <Card>
                    <CardHeader
                        title={
                            <Typography variant='h5'>Edit Validator</Typography>
                        }
                        avatar={
                            <Tooltip title="Kembali">
                                <IconButton variant="outlined" onClick={() => {
                                    setEdit(null)
                                }} color="error"><ArrowBack /></IconButton>
                            </Tooltip>
                        }
                    />
                    <CardContent>
                        <Form edit={edit} setEdit={setEdit} />
                    </CardContent>
                </Card>
            }
        </>
    )
}

export default Verifikator
export { Data as DataVerifikator }